import gql from "graphql-tag";

export const MAILING_LIST_QUERY = gql`
  query GetMailingListQuery($id: ID!) {
    mailingList(where: { id: $id }) {
      description
      address
      id
      subscribedMembers
      members_roles {
        name
        users {
          id
        }
      }
      members_users {
        id
        name
      }
      members {
        id
        name
        email
        subscribed
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/queries/MailingListQuery/queries.ts